// KnockoutScoreboard.jsx
import React from 'react';
import './KnockoutScoreboard.css';

export default function KnockoutScoreboard({
  // Верхний полуфинал
  semiTopP1,
  semiTopP2,
  semiTopScore1,
  semiTopScore2,
  // Нижний полуфинал
  semiBotP1,
  semiBotP2,
  semiBotScore1,
  semiBotScore2,
  // Финал
  finalP1,
  finalP2,
  finalScore1,
  finalScore2,
  // Чемпион
  championName,
}) {
  return (
    <div className="knockout-container">
      {/* Верхний полуфинал */}
      <div className="semi semi1">
        <div className="player-box">
          <span className="player-name">{semiTopP1}</span>
          <span className={`player-score ${semiTopScore1 > semiTopScore2 ? 'green' : 'red'}`}>
            {semiTopScore1}
          </span>
        </div>
        <div className="player-box">
          <span className="player-name">{semiTopP2}</span>
          <span className={`player-score ${semiTopScore2 > semiTopScore1 ? 'green' : 'red'}`}>
            {semiTopScore2}
          </span>
        </div>
      </div>

      {/* Нижний полуфинал */}
      <div className="semi semi2">
        <div className="player-box">
          <span className="player-name">{semiBotP1}</span>
          <span className={`player-score ${semiBotScore1 > semiBotScore2 ? 'green' : 'red'}`}>
            {semiBotScore1}
          </span>
        </div>
        <div className="player-box">
          <span className="player-name">{semiBotP2}</span>
          <span className={`player-score ${semiBotScore2 > semiBotScore1 ? 'green' : 'red'}`}>
            {semiBotScore2}
          </span>
        </div>
      </div>

      {/* Финал */}
      <div className="final-match">
        <div className="player-box">
          <span className="player-name">{finalP1}</span>
          <span className={`player-score ${finalScore1 > finalScore2 ? 'green' : ''}`}>
            {finalScore1}
          </span>
        </div>
        <div className="player-box">
          <span className="player-name">{finalP2}</span>
          <span className={`player-score ${finalScore2 > finalScore1 ? 'green' : ''}`}>
            {finalScore2}
          </span>
        </div>
      </div>

      {/* Чемпион */}
      <div className="champion-box">
        <span className="champion-name">{championName}</span>
        <img src="/img/trophy.png" alt="Трофей" className="trophy" />
      </div>
    </div>
  );
}
